// Унифицированные хелперы для нового поля orders.express после удаления
// boolean-колонки isExpress. Поле принимает 4 значения + null:
//   null            — ещё не определялось
//   'none'          — точно не экспресс
//   'express_print' — экспресс печать
//   'express_edit'  — ускоренная редактура
//   'urep'          — УРЭП

export type ExpressType = "none" | "express_print" | "express_edit" | "urep";
export type ExpressValue = ExpressType | null | undefined;

// «Экспресс книгой» считаются ТОЛЬКО express_print и urep (см. требование от
// клиента). express_edit и none — не экспресс-книги для подсчётов и сроков.
export const isExpressBook = (express: ExpressValue): boolean =>
  express === "urep" || express === "express_print";

// Любая экспресс-услуга (включая редактуру). Полезно для фильтра «всё что
// не обычный заказ».
export const hasAnyExpress = (express: ExpressValue): boolean =>
  express === "urep" ||
  express === "express_print" ||
  express === "express_edit";

// Что попадает в приоритетную «УРЭП»-таблицу на /editor — урэп и ускоренная
// редактура (то, что требует первоочередной редактуры). Экспресс печать
// для редактора не важна — это срочный заказ к печати, не к редактуре.
export const isEditorPriority = (express: ExpressValue): boolean =>
  express === "urep" || express === "express_edit";

export const expressLabel = (express: ExpressValue): string => {
  switch (express) {
    case "urep":
      return "УРЭП";
    case "express_print":
      return "Экспресс печать";
    case "express_edit":
      return "Уск. редактура";
    case "none":
      return "Обычный";
    default:
      return "—";
  }
};

// Прайс экспресс-услуг в тенге — auto-fill в формах создания транзакции
// (`/transactions`) и клиента (`/sales`) при выборе соответствующего типа.
export const EXPRESS_PRICE_KZT: Record<"express_edit" | "express_print" | "urep", number> = {
  express_edit: 6000,   // УР
  express_print: 9000,  // ЭП
  urep: 15000,          // УРЭП
};

// Краткий бейдж, чтобы не тянуть длинные подписи в таблицы.
export const expressShort = (express: ExpressValue): string => {
  switch (express) {
    case "urep":
      return "УРЭП";
    case "express_print":
      return "Экспр.";
    case "express_edit":
      return "Уск.";
    default:
      return "";
  }
};
